module.exports = __webpack_public_path__ + "img/help.35718e56.png";